export default __webpack_public_path__ + "static/media/Icon ion-help-outline_v2.477f98c8.svg";